module.exports = __webpack_public_path__ + "static/media/Vortex-2WD-OV-3500.4689da52.png";